import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Box, CircularProgress } from '@mui/material';

/**
 * AuthGuard component to protect routes that require authentication
 * Allows guest users but redirects unauthenticated users to login
 */
function AuthGuard({ children, requireAuth = false }) {
  const auth = useAuth() || { user: null, isAuthenticated: false, loading: false, isGuest: false };
  const { isAuthenticated, loading, isGuest } = auth;
  
  // Show loading spinner while checking authentication status
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }
  
  // If route requires full auth (not guest), redirect guests to login
  if (requireAuth && isGuest) {
    return <Navigate to="/login" replace />;
  }
  
  // Redirect to login if not authenticated at all (no user or guest)
  if (!isAuthenticated && !isGuest) {
    return <Navigate to="/login" replace />;
  }
  
  // Render children if authenticated or guest (depending on requireAuth)
  return children;
}

export default AuthGuard;
